import { __rest } from '../../../../_virtual/_tslib.js';
import React__default from 'react';
import { BottomSheetBodyWrapper } from './styles.js';

function BottomSheetBody(_a) {
    var { hasBodyPadding = true, children, bodyRef, id } = _a, props = __rest(_a, ["hasBodyPadding", "children", "bodyRef", "id"]);
    return (React__default.createElement(BottomSheetBodyWrapper, Object.assign({}, props, { hasBodyPadding: hasBodyPadding, "data-testid": `${props['data-testid']}-bottom-sheet-body`, ref: bodyRef, id: id }), children));
}

export { BottomSheetBody };
